import moment from 'moment';

export const realtimeSlice = set => ({
  realtimeDataRaw: null,
  realtimeData: null,
  timezone: moment.tz.guess(),
});
